import Vue from 'vue';
import app from '@/App.vue';
import store from '@/store';
import router from '@/router';
import { helpers } from '@moeco-platform/moeco-components';



// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
import mapbox from 'mapbox-gl';

window.mapboxgl = mapbox;

import '@/styles/base.scss';
import '@moeco-platform/moeco-components/dist/moeco-components.css';
import '@moeco-platform/moeco-components/src/assets/fonts/stylesheet.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';


import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import VueToast from 'vue-toast-notification';
Vue.use(VueToast, {
  position: 'top'
});

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

const urlParams = new URLSearchParams(window.location.search);
const sensorUid = urlParams.get('uid');

if (!sensorUid) {
  throw console.warn('sensorUid  is no setted in adress string');
}

store.commit('shipments/setSensorUid', sensorUid);

import {
  TextInput, SelectInput,
  ButtonInput, CheckboxInput,
  LabeledInput, RadioInput,
  SwitchInput, SegmentedControl,
  SearchInput, PasswordInput
} from '@moeco-platform/moeco-components';

Vue.component('TextInput', TextInput);
Vue.component('SelectInput', SelectInput);
Vue.component('ButtonInput', ButtonInput);
Vue.component('SearchInput', SearchInput);
Vue.component('SwitchInput', SwitchInput);
Vue.component('CheckboxInput', CheckboxInput);
Vue.component('SegmentedControl', SegmentedControl);
Vue.component('RadioInput', RadioInput);
Vue.component('LabeledInput', LabeledInput);
Vue.component('PasswordInput', PasswordInput);

import { Chart } from 'highcharts-vue';
Vue.component('Highcharts', Chart);

import vmodal from 'vue-js-modal';
Vue.use(vmodal);


import VueContentPlaceholders from 'vue-content-placeholders';
Vue.use(VueContentPlaceholders);

const i18n = helpers.i18n;

new Vue({
  store,
  router,
  i18n,
  render: h => h(app),
}).$mount('#app');